/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_RowInputs */

const en_platform_plan_row = /** @type {(inputs: Platform_Plan_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dumbbell row`)
};

const pl_platform_plan_row = /** @type {(inputs: Platform_Plan_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiosłowanie hantlą`)
};

/**
* | output |
* | --- |
* | "Dumbbell row" |
*
* @param {Platform_Plan_RowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_row = /** @type {((inputs?: Platform_Plan_RowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_RowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_row(inputs)
	return en_platform_plan_row(inputs)
});